/**
 * Native SIP REGISTER target (UDP/TCP). Prefer backend sipRegistrarHost (UCM LAN IP), not WSS hostname.
 */
export const resolveNativeSipRegistrarHost = (config) => {
  const fromApi = String(config?.sipRegistrarHost || "").trim();
  if (fromApi) {
    return fromApi;
  }
  const domain = String(config?.sipDomain || "").trim();
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(domain)) {
    return domain;
  }
  const wssUrl = config?.sipWebSocketUrl;
  if (wssUrl) {
    try {
      const hostname = new URL(String(wssUrl).trim()).hostname;
      if (hostname) {
        return hostname;
      }
    } catch {
      // ignore
    }
  }
  return domain;
};
